import { render, staticRenderFns } from "./scCountdownWidget.vue?vue&type=template&id=5d70c0e1&scoped=true&"
import script from "./scCountdownWidget.vue?vue&type=script&lang=js&"
export * from "./scCountdownWidget.vue?vue&type=script&lang=js&"
import style0 from "./scCountdownWidget.vue?vue&type=style&index=0&id=5d70c0e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d70c0e1",
  null
  
)

export default component.exports